import { createAction } from 'redux-actions';
import type { ActionFunctionAny } from 'redux-actions';
import { CLEAR_STORE } from './constants';
import type { Action } from 'redux';

export const clearStoreAction: ActionFunctionAny<Action<any>> = createAction(CLEAR_STORE);